import type { RMR } from "epsm-api-types/models";
import type { PriceInfo } from "epsm-api-types/ws";
import type { UTCTimestamp } from "lightweight-charts";
import type {
	IContext,
	PineJS,
	StudyMetaInfo,
} from "@/charting_library/charting_library";
import { chartColors } from "@/components/widgets/Chart/const";
import { Subcharts } from "@/components/widgets/Chart/types";
import { getSlopeColorId } from "../CustomIndicatorService";
import { RMRIndicatorService } from "./RMRIndicatorService";

export class IndexRatioTrendSlopeIndicatorService extends RMRIndicatorService {
	fieldMapper(item: RMR): PriceInfo<UTCTimestamp> {
		return {
			time: item.date.getTime() as UTCTimestamp,
			close: item.index_ratio_trend_10d_slope,
		} as PriceInfo<UTCTimestamp>;
	}

	get requiredFields() {
		return ["index_ratio_trend_10d_slope"];
	}

	getPlotsData(PineJS: PineJS, context: IContext): number[] {
		const slope = PineJS.Std.close(context);
		const colorId = getSlopeColorId(slope);

		return [slope, colorId];
	}

	get styles() {
		return {
			plot_0: {
				title: Subcharts.InxRatTrendSlope,
				histogramBase: 0,
			},
		};
	}

	get plots(): StudyMetaInfo["plots"] {
		return [
			{
				id: "plot_0",
				type: "line",
			},
			{
				id: "plot_1",
				type: "colorer",
				target: "plot_0",
				palette: "paletteId1",
			},
		] as StudyMetaInfo["plots"];
	}

	get defaults(): StudyMetaInfo["defaults"] {
		return {
			styles: {
				plot_0: {
					plottype: 0,
					linewidth: 3,
					linestyle: 0,
					visible: true,
					transparency: 0,
				},
			},
			palettes: {
				paletteId1: {
					colors: {
						0: {
							color: chartColors.down,
							width: 3,
							style: 0,
						},
						1: {
							color: chartColors.consolidation,
							width: 3,
							style: 0,
						},
						2: {
							color: chartColors.up,
							width: 3,
							style: 0,
						},
					},
				},
			},
		};
	}

	get palettes(): StudyMetaInfo["palettes"] {
		return {
			paletteId1: {
				colors: {
					0: {
						name: "Down color",
					},
					1: {
						name: "Consolidation color",
					},
					2: {
						name: "Up color",
					},
				},
			},
		};
	}
}
